<template>
    <div v-loading="loading" v-show='show' align="center" class="booking-detail notranslate">
        <span @click="back" class="back-btn"><i class="el-icon el-icon-arrow-left"></i></span>
        <el-row style=" margin: 30px 0 75px">
            <label class="page-label">{{title}}</label>
        </el-row>

        <div v-show="!expired && wantToCancel && !canceled" class="warning">
            {{$t("bookingConfirm.detail.warning.wantToCancel")}}<br><br><span class="default" v-html="warning"></span>
        </div>
        <div v-show="canceled" class="warning">{{booking.cancelByAdmin ? $t("bookingConfirm.detail.warning.canceledByAdmin") : $t("bookingConfirm.detail.warning.canceled")}}</div>

        <el-row class="wrapper">
            <div class="label">{{$t("bookingConfirm.detail.label.bookingNumber")}}</div>
            <div class="data">{{booking.bookingNumber}}</div>
        </el-row>
        <el-row class="wrapper">
            <div class="label">{{$t("bookingConfirm.detail.label.facilityName")}}</div>
            <div class="data">{{booking.facilityName}}</div>
        </el-row>
        <el-row class="wrapper">
            <div class="label time">{{$t("bookingConfirm.detail.label.bookingTime")}}</div>
            <div class="data" style="white-space: normal;">{{booking.bookingDate}} <span style="white-space: nowrap">{{booking.timeRange}}</span>
            </div>
        </el-row>
        <el-row class="wrapper">
            <div class="label" :style="'height: ' + height + 'px'">{{$t("bookingConfirm.detail.label.slotType")}}</div>
            <div class="data">
                <p v-for="bookedSlotType in booking.bookedSlotTypes" class="slot-type">
                    <span style="padding-right: 15px">{{bookedSlotType.slotType.name}}</span>{{bookedSlotType.numberBookedSlot}}{{$t("bookingConfirm.detail.personUnit")}}
                </p>
            </div>
        </el-row>
        <el-row class="wrapper" v-if="booking.coupon">
            <div class="label coupon">{{booking.coupon.name}}</div>
            <div class="data">{{booking.coupon.data}}</div>
        </el-row>
        <el-row class="wrapper">
            <div class="label">{{$t("bookingConfirm.detail.label.price")}}</div>
            <div class="data">¥ {{moneyFormat(booking.price)}}</div>
        </el-row>
        <div class="margin-bottom-40"></div>
        <el-button class="cancel-booking" v-show="!expired && !canceled && wantToCancel" @click="confirmCancelBooking">
            {{$t("bookingConfirm.detail.btn.cancelBooking")}}
        </el-button>
        <el-button class="cancel" @click="cancel">{{$t("bookingConfirm.detail.btn.back")}}</el-button>
        <p v-show="isShowChangeDateButton" class="change-date-warning" >予約日の変更、予約のキャンセルは前日の18時までとなります。</p>
        <el-button class="change-date" v-show="isShowChangeDateButton" @click="changeDate">
            {{$t("bookingConfirm.detail.btn.changeDate")}}
        </el-button>
        <el-button class="cancel-booking margin-top-30" v-show="!expired && !canceled && !wantToCancel" @click="cancelBooking">
            {{$t("bookingConfirm.detail.btn.cancelBooking")}}
        </el-button>
    </div>
</template>

<script>
    import BookingConfirmApi from "../../api/bookingConfirm/BookingConfirmApi";
    import AlertService from "../../service/alert.service";
    import moment from "moment";
    import Pages from "../../router/Pages";

    export default {
        name: "BookingDetail",
        data() {
            return {
                booking: {},
                show: false,
                wantToCancel: false,
                canceled: false,
                expired: false,
                title: this.$t("bookingConfirm.detail.title.detail"),
                discountUnit: {
                    DISCOUNT_BY_PERCENT: "%",
                    DISCOUNT_BY_VALUE: "¥"
                },
                warning: "",
                height: 55,
                loading: false
            }
        },
        computed: {
            isShowChangeDateButton(){
                return !this.expired && !this.canceled && !this.wantToCancel && !this.isAfter18hOfDayBeforeBookingDate();
            }
        },
        methods: {
            isAfter18hOfDayBeforeBookingDate(){
                if(!this.booking.bookingDate)
                    return true;

                const bookingDate = new Date(this.booking.bookingDate.split(" ")[0]);
                const _18hOfDayBeforeBookingDate = new Date(bookingDate.getFullYear(),bookingDate.getMonth(), bookingDate.getDate() - 1,18,0,0);
                const now = new Date();
                return now.getTime() > _18hOfDayBeforeBookingDate.getTime();
            },
            moneyFormat(money) {
                let lowerThanZero = money < 0;
                var strValue = "" + money;
                if (lowerThanZero)
                    strValue = strValue.slice(1);

                let afterComma;
                if (strValue.indexOf(".") > -1) {
                    var index = strValue.indexOf(".");
                    afterComma = strValue.substring(index + 1, strValue.length);
                    strValue = strValue.substring(0, index);
                }
                strValue = Array.from(strValue).reverse().join('');
                let result = strValue.match(/(.{1,3})/g);
                for (let i = 0; i < result.length; i++) {
                    result[i] = Array.from(result[i]).reverse().join('');
                }
                result = result.reverse();
                if (afterComma) {
                    result = result + "." + afterComma;
                }
                return (lowerThanZero ? "-" : "") + result;
            },
            back() {
                this.show = false;
                this.wantToCancel = false;
                this.canceled = false;
                this.expired = false;
                this.booking = {};
                window.history.pushState({}, "", window.location.pathname);
                this.$emit("back");
            },
            validateDate: function () {
                let today = moment(new Date());
                let bookingDate = this.booking.bookingDate.split(" ")[0];
                let previousDateOfBookingDate = new Date(new Date(bookingDate) - 864e5);
                console.log("Today: " + new Date());
                console.log("Booking date: "+ new Date(bookingDate));
                console.log("Previous of booking date: "+ previousDateOfBookingDate);
                previousDateOfBookingDate.setHours(0);
                previousDateOfBookingDate.setMinutes(0);
                previousDateOfBookingDate.setSeconds(0);
                previousDateOfBookingDate.setMilliseconds(0);
                let firstTimeOfPreviousDateOfBookingDate = previousDateOfBookingDate;
                console.log(firstTimeOfPreviousDateOfBookingDate);
                let expiredTimeOutByPreviousDate = new Date(firstTimeOfPreviousDateOfBookingDate.setSeconds(firstTimeOfPreviousDateOfBookingDate.getSeconds() +
                    parseInt(process.env.VUE_APP_EXPIRED_TIME_OF_PREVIOUS_DATE_WHEN_CANCEL_BOOKING)));

                console.log(new Date().getTime() >= expiredTimeOutByPreviousDate.getTime());
                if (new Date().getTime() >= expiredTimeOutByPreviousDate.getTime()) return false;
                if (bookingDate > today.format("YYYY/MM/DD")) return true;
                if (bookingDate < today.format("YYYY/MM/DD")) return false;
                return today.format("hh:mm") < this.booking.timeRange.split(" - ")[0];
            },
            load(booking, index) {
                this.index = index;
                this.show = true;
                this.booking = booking;
                this.expired = !this.validateDate();

                this.canceled = booking.status === "CANCEL" || booking.status === "REFUND" || booking.status === "FULL_REFUND" || booking.status === "REFUND_ERROR";
                this.booking.bookedSlotTypes = this.booking.bookedSlotTypes.filter(slotType => slotType.numberBookedSlot);
                this.height = 36 + this.booking.bookedSlotTypes.length * 26;
                this.loading = true;
                BookingConfirmApi.detail(booking.code).then(response => {
                    this.loading = false;
                    if (response.couponDto)
                        this.booking.coupon = {
                            name: response.couponDto.name,
                            data: response.couponDto.discountValue + " OFF"
                        }
                }).catch(() => {
                    this.loading = false;
                });
            },
            cancel() {
                if (!this.canceled && this.wantToCancel) {
                    //scroll top
                    document.body.scrollTop = 0; //Safari
                    document.documentElement.scrollTop = 0; //Other
                    this.title = this.$t("bookingConfirm.detail.title.detail");
                    this.wantToCancel = false;
                } else {
                    this.back();
                }
            },
            confirmCancelBooking() {
                if (!this.validateDate()) {
                    AlertService.error("Booking expired");
                    this.canceled = true;
                    return;
                }
                this.loading = true;
                BookingConfirmApi.cancel(this.booking.code).then(response => {
                    this.loading = false;
                    this.wantToCancel = false;
                    console.log("Cancel result: ");
                    console.log(response);

                    let hideDetail = false;
                    this.title = this.$t("bookingConfirm.detail.title.detail");
                    if (response.cancelingExpired) {
                        AlertService.error(this.$t("bookingConfirm.detail.message.expiredToCancel"));
                        this.expired = true;
                    } else if (response.cancelingCanceled) {
                        AlertService.error(this.$t("bookingConfirm.detail.message.canceledToCancel"))
                        this.canceled = true;
                    } else {
                        if (response.bookingDto.status === "REFUND" || response.bookingDto.status === "FULL_REFUND") {
                            AlertService.success(this.$t("bookingConfirm.detail.message.cancelSuccessfullyAndFeeWasRefunded"))
                        } else if (response.bookingDto.status === "REFUND_ERROR") {
                            AlertService.error(this.$t("bookingConfirm.detail.message.cancelSuccessfullyAndFeeWasNotRefunded"))
                        } else {
                            /** Status is "CANCEL":
                             * + Case 1: Booking user is admin. After, admin canceled this booking => charge_id = null because need not to call Stripe service to pay.
                             *           => Don't care because this is business of admin!
                             * + Case 2: End user booked but price is 0 => charge_id = null because need not to call Stripe service to pay.
                             **/
                             AlertService.success(this.$t("bookingConfirm.detail.message.cancelSuccessfully"))
                        }

                        this.canceled = true;
                        this.show = false;
                        hideDetail = true;
                    }
                    this.$emit("canceled", this.index, hideDetail);
                });
            },
            cancelBooking() {
                if (!this.validateDate()) {
                    AlertService.error("Booking expired");
                    this.canceled = true;
                    return;
                }

                this.wantToCancel = true;
                //scroll top
                document.body.scrollTop = 0; //Safari
                document.documentElement.scrollTop = 0; //Other
                this.title = this.$t("bookingConfirm.detail.title.cancel");
            },
            changeDate() {
                if (!this.validateDate() && this.isAfter18hOfDayBeforeBookingDate()) {
                    AlertService.error("Booking expired");
                    this.canceled = true;
                    return;
                }
                this.$router.push(Pages.changeBookingDate.path +
                    "?bookingCode=" + this.booking.code +
                    "&facilityCode=" + this.booking.facilityCode);
            }
        },
        mounted() {
            BookingConfirmApi.getWarning().then(response => {
                this.warning = response;
            })
        }
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 1000px) {
        .cancel-booking, .cancel, .change-date {
            width: 70%;
            margin: 10px auto;
        }

        .booking-detail {
            width: 100%;
        }
        .page-label {
            font-size: 30px;
            position: relative;
            display: inline-block;
            width: calc(80% - 50px);
            margin: 0 calc(10% + 25px);
        }
        .label {
            width: 40%;

            &.time {
                height: 57px;
            }
        }
        .data {
            width: 60%;
            padding: 10px 10px 10px 20px;
        }
    }

    @media screen and (min-width: 1000px) {

        .cancel-booking, .cancel, .change-date {
            width: 40%;
            margin: 10px auto !important;
            display: block;
            text-align: center;
        }

        .booking-detail {
            width: 80%;
        }

        .cancel-message {
            position: absolute;
        }
        .page-label {
            font-size: 40px;
        }
        .label {
            width: 30%;
        }
        .data {
            width: 70%;
            padding: 10px 10px 10px 50px;
        }
    }

    .booking-detail {
        margin: auto;
        position: relative;
    }

    .page-label {
        white-space: nowrap;
        font-weight: bold;
    }

    .list {
        .btn {
            width: 100%;
            text-align: left;
            position: relative;
            border-radius: 0;
        }
    }

    .next-btn, .back-btn {
        position: absolute;
        cursor: pointer;
        font-size: 40px;
        font-weight: bold;
        z-index: 1;

        &:hover {
            color: #2b3b4e;
        }

        &:active {
            color: #455664;
        }
    }

    .back-btn {
        left: 0;
    }

    .next-btn {
        right: 20px;
        top: calc(50% - 20px);
    }

    .wrapper {
        margin-bottom: 10px;

        .label {
            vertical-align: top;
            box-sizing: border-box;
            display: inline-block;
            text-align: left;
            background-color: #cfe2f3;
            padding: 10px;
            font-weight: bold;

            &.coupon {
                background-color: #f6b26b;
            }
        }

        .data {
            font-weight: bold;
            box-sizing: border-box;
            display: inline-block;
            text-align: left;

            .slot-type {
                margin: 0;

                &:first-child {
                    margin-top: 8px;
                }

                &:last-child {
                    margin-bottom: 8px;
                }

            }
        }
    }

    .cancel-booking {
        background-color: red;
        color: #fff;
    }

    .change-date-warning{
        margin-top: 20px;
        margin-bottom: 0px;
        font-weight: bold;
    }


    .cancel-booking {
        margin-top: 20px;
    }

    .warning {
        text-align: left;
        border-radius: 10px;
        border: 1px solid red;
        font-weight: bold;
        padding: 15px;
        margin-bottom: 20px;
        color: red;
    }

    .change-date {
        background-color: #4B86E8;
        color: white;
    }

    .default {
        color: black;
        font-weight: normal;
    }
</style>